import { InvalidateQueryFilters, useQueryClient } from '@tanstack/react-query'
import { AnimatedError } from 'components/animatedError'
import { useAuth, useCurrentAccount } from 'hooks/admin/useAuth'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { UserRole } from 'types/Organization'

import { Container, Input, SubmitButton, Title } from './login.styles'

interface FormData {
    email: string
    password: string
}

const isMobileDevice = () => /Mobi|Android/i.test(navigator.userAgent)

export const Login: React.FC = () => {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm<FormData>()
    const { signIn } = useAuth()
    const { refetch: refetchCurrentAccount } = useCurrentAccount()

    const [errorMessage, setErrorMessage] = useState<string>('')
    const queryClient = useQueryClient()

    const onSubmit = async (data: { email: string; password: string }) => {
        try {
            await signIn(data.email, data.password)

            const currentAccount = await refetchCurrentAccount()
            const role = currentAccount.data?.role

            if (isMobileDevice() && role === UserRole.orgAdmin) {
                window.location.href = '/admin/jegyellenorzes/esemenyvalasztas'
            } else {
                switch (role) {
                    case UserRole.superAdmin:
                        window.location.href = '/admin/szervezetek'
                        break
                    case UserRole.orgAdmin:
                        window.location.href = '/admin/esemenyek'
                        break
                    default:
                        window.location.href = '/'
                }
            }

            queryClient.invalidateQueries(['currentAccount'] as InvalidateQueryFilters)
        } catch (error: any) {
            console.error(error.message)
            setErrorMessage('Érvénytelen email vagy jelszó. Kérjük próbálja újra.')
        }
    }

    return (
        <Container>
            <Title>Bejelentkezés</Title>
            <form onSubmit={handleSubmit(onSubmit)} style={{ display: 'flex', flexDirection: 'column', width: '15rem' }}>
                <Input type="email" placeholder="Email" {...register('email', { required: 'Az email cím megadása kötelező.' })} />
                {errors.email && <AnimatedError>{errors.email.message}</AnimatedError>}

                <Input type="password" placeholder="Jelszó" {...register('password', { required: 'A jelszó megadása kötelező.' })} />
                {errors.password && <AnimatedError>{errors.password.message}</AnimatedError>}

                {errorMessage && <AnimatedError>{errorMessage}</AnimatedError>}
                <SubmitButton type="submit">Bejelentkezés</SubmitButton>
            </form>
        </Container>
    )
}
